import React, { ReactElement } from 'react';
import {
  IOutSampleTableData,
  buildOutSampleStatistics,
  outSampleColumns,
} from './outSample.data';
import CustomTable from '../../../../../tables/CustomTable';
import GridItem from '../../../../../layout/GridComponents/GridItem';
import { VarBacktestApiResponse } from '../../queries';

interface Props {
  varBacktestData: VarBacktestApiResponse;
}

function OutSampleTable({ varBacktestData }: Props): ReactElement {
  const tableData = buildOutSampleStatistics([varBacktestData]);

  return (
    <GridItem xs={3} card>
      <CustomTable<IOutSampleTableData>
        columns={outSampleColumns}
        showToolbar={true}
        title="Out-sample Statistics"
        options={{
          paging: false,
          exportButton: true,
        }}
        loading={false}
        data={tableData}
      />
    </GridItem>
  );
}

export default OutSampleTable;
